<template>
  <tg-dialog
    ref="dialog"
    v-bind="{ ...$attrs }"
    v-on="$listeners"
    class="history-reward-info"
    :title="$t('component.dialog.member_batch.title')"
    :showFooter="false"
    :showCancelBtn="false"
    width="40%"
    append-to-body
    :visible.sync="visible"
    :showIcon="false"
  >
    <el-container direction="vertical" class="info--container">
      <template>
        <el-row
          type="flex"
          justify="start"
          class="info-row"
          v-for="(item, index) in items"
          :key="index"
        >
          <el-col :span="6" class="info-row--column">
            <span>
              {{ $t(item.label) }}
            </span>
          </el-col>
          <el-col :span="12" class="info-row--value">
            <el-row type="flex" justify="start" class="el-col-24">
              <template v-if="item.isBlockBtn === true">
                <tg-blocked-btn
                  :action="item.blocked"
                  :blocked="0"
                  :targetName="''"
                  :text="$t('component.btn.bulk_close')"
                  class="blocked-btn close"
                  :class="{ active: blockedArray[item.blocked] == 1 }"
                  @on-click="handleBlockBtnClick"
                ></tg-blocked-btn>
                <tg-blocked-btn
                  :action="item.blocked"
                  :blocked="1"
                  :targetName="''"
                  :text="$t('component.btn.bulk_open')"
                  class="blocked-btn open"
                  :class="{ active: blockedArray[item.blocked] == 0 }"
                  @on-click="handleBlockBtnClick"
                ></tg-blocked-btn>
              </template>
              <template v-else-if="item.name == 'handicap_id'">
                <el-select v-model="batchData.handicap_id">
                  <el-option
                    v-for="(hadicap, i) in hadicapArray"
                    :key="i"
                    :value="hadicap.value"
                    :label="hadicap.name"
                    >{{ hadicap.name }}</el-option
                  >
                </el-select>
                <!-- <el-radio-group v-model="batchData.handicap_id">
                  <template v-for="(hadicap, i) in hadicapArray">
                    <el-radio
                      :key="i"
                      :label="hadicap.value"
                      :name="hadicap.name"
                      :style="{width:'50%',padding: '12px 5px 0 10px;'}"
                      size="large"
                    >{{ hadicap.name }}
                    </el-radio>
                  </template>
                </el-radio-group> -->
              </template>
              <template v-else-if="item.name == 'limit_bet_value'">
                <el-input
                  :placeholder="$t('component.form.input.placeholder.number')"
                  v-model="batchData.limit_bet_value"
                  class="tg-input col-12"
                  size="small"
                  type="number"
                  clearable
                ></el-input>
              </template>
            </el-row>
          </el-col>
          <el-col :span="6" class="info-row--action">
            <tg-button
              round
              :classes="['tg-btn--search']"
              :disabled="item.reward <= 0"
              @click.native="confirmHandler(item)"
            >
              {{ $t("component.btn.save") }}
            </tg-button>
          </el-col>
        </el-row>
      </template>
    </el-container>
  </tg-dialog>
</template>

<script>
// import TgLayout from "@/layout/TgLayout";
// import TgTable from "@/components/table/TgTable";
import TgButton from "@/components/button/TgButton";
import TgDialog from "@/components/dialog/TgDialog.vue";
import TgBlockedBtn from "@/components/button/TgBlockedBtn";

export default {
  inheritAttrs: false,
  components: {
    TgButton,
    TgDialog,
    TgBlockedBtn,
  },
  data() {
    return {
      visible: false,
      blockedArray: {
        login: 1,
        bet: 1,
        transfermoney: 1,
      },
      batchData: {
        handicap_id: "",
        limit_bet_value: 0,
      },
      selectedHadicap: "",
    };
  },
  props: {
    items: Array,
    hadicapArray: Array,
  },
  methods: {
    show() {
      this.visible = true;
    },
    handleBlockBtnClick(action, blocked) {
      this.blockedArray[action] = blocked;
    },
    confirmHandler(row) {
      this.$emit("confirm", row, this.blockedArray, this.batchData);
    },
  },
};
</script>
